<template>
  <div class="page">
    <div class="weui-msg">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-warn weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">操作失败</h2>
        <p class="weui-msg__desc">{{message}}</p>
      </div>
      <div class="weui-msg__opr-area">
        <p class="weui-btn-area">
          <a href="javascript:;" class="weui-btn weui-btn_primary" @click="goHome">返回主页</a>
          <a v-if="code==40003" href="javascript:;" class="weui-btn weui-btn_default" @click="login">登录</a>
          <a href="javascript:;" class="weui-btn weui-btn_default" @click="$router.back()">返回上一页</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "@/util/auth.js";

export default {
  data() {
    return {
      code: null,
      message: null,
      prevPath: null
    };
  },
  mounted() {
    this.message = this.$route.params.message;
    this.code = this.$route.params.code;
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevPath = from.path
    })
  },
  methods: {
    goHome() {
      var me = this;
      Auth.get()
        .then(function(info) {
          me.$router.push("/" + info.appId.replace("-app", ""));
        })
        .catch(() => {
          me.$router.push("/");
        });
    },
    login() {
      var me = this;
      me.$router.replace({
        name: 'Login',
        query: {
          page: me.prevPath
        }
      });
    }
  }
};
</script>